import { render, staticRenderFns } from "./TopicComment.vue?vue&type=template&id=9f9956b0&scoped=true&"
import script from "./TopicComment.vue?vue&type=script&lang=js&"
export * from "./TopicComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9956b0",
  null
  
)

export default component.exports